import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/ocean32.dcpltechnology.com/src/app/target-region/index.jsx");
